import React, { useState, useEffect } from 'react';

const useFocusCss = (isFocused, className, focusedClass) => {
  useEffect(() => {
    const element = document.querySelector(className);
    if(element){
      if (isFocused) {
        element.classList.add(focusedClass);
      } else {
        element.classList.remove(focusedClass);
      }
    }

  }, [isFocused]);
};

export default useFocusCss
